import { formatCapturedAt, formatCurrency } from "../pages/dashboardUtils";
import {
  ghostButtonStyle,
  primaryButtonStyle,
  secondaryButtonStyle,
} from "../pages/dashboardStyles";

export default function SubscriptionPaywall({
  billingOverview,
  isActivating = false,
  onActivate,
  onLogout,
  t,
}) {
  if (!billingOverview || billingOverview.access_granted) {
    return null;
  }

  const pricePreview = billingOverview.price_preview || {};
  const monthlyPriceLabel = formatCurrency(
    pricePreview.monthly_price_local,
    pricePreview.currency_code
  );
  const usdEquivalentLabel = formatCurrency(
    pricePreview.monthly_price_usd,
    "USD"
  );
  const trialEndedAtLabel = billingOverview.trial_ends_at
    ? formatCapturedAt(billingOverview.trial_ends_at)
    : t?.("common.no_data", "n/d") || "n/d";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1200,
        background: "rgba(15, 23, 42, 0.54)",
        backdropFilter: "blur(8px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 22,
      }}
    >
      <div
        style={{
          width: "min(94vw, 520px)",
          borderRadius: 28,
          background:
            "linear-gradient(160deg, #fff7ed 0%, #ffffff 52%, #fff1f2 100%)",
          border: "1px solid rgba(251, 146, 60, 0.28)",
          boxShadow: "0 34px 90px rgba(15, 23, 42, 0.28)",
          padding: 26,
          color: "#431407",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "8px 14px",
            borderRadius: 999,
            background: "#fff1f2",
            color: "#be123c",
            fontWeight: 800,
            fontSize: 13,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          {t?.("billing.paywall.badge", "Premium") || "Premium"}
        </div>

        <h2 style={{ marginTop: 16, marginBottom: 10, fontSize: 30, lineHeight: 1.08 }}>
          {t?.("billing.paywall.title", "Seu trial acabou") || "Seu trial acabou"}
        </h2>
        <p style={{ margin: 0, color: "#7c2d12", lineHeight: 1.6 }}>
          {t?.(
            "billing.paywall.description",
            "Assine para continuar usando comparacao de mercados, listas inteligentes e catalogos em tempo real no PennyPantry."
          ) ||
            "Assine para continuar usando comparacao de mercados, listas inteligentes e catalogos em tempo real no PennyPantry."}
        </p>

        <div
          style={{
            marginTop: 20,
            padding: 20,
            borderRadius: 24,
            background: "#ffffff",
            border: "1px solid #fed7aa",
            display: "grid",
            gap: 10,
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 700, color: "#9a3412" }}>
            {t?.("billing.plan.label", "Plano mensal PennyPantry") ||
              "Plano mensal PennyPantry"}
          </div>
          <div style={{ fontSize: 34, fontWeight: 900, color: "#dc2626" }}>
            {monthlyPriceLabel}
            <span style={{ fontSize: 16, color: "#7c2d12", marginLeft: 8 }}>
              {t?.("billing.plan.per_month", "/mes") || "/mes"}
            </span>
          </div>
          <div style={{ color: "#7c2d12" }}>
            {t?.("billing.plan.usd_equivalent", "Equivale a {{amount}} por mes.", {
              amount: usdEquivalentLabel,
            }) || `Equivale a ${usdEquivalentLabel} por mes.`}
          </div>
          <div style={{ color: "#7c2d12" }}>
            {t?.("billing.plan.trial_ended_at", "Trial encerrado em {{date}}.", {
              date: trialEndedAtLabel,
            }) || `Trial encerrado em ${trialEndedAtLabel}.`}
          </div>
        </div>

        <div style={{ marginTop: 16, display: "grid", gap: 10, color: "#7c2d12" }}>
          <div>
            {t?.(
              "billing.paywall.feature_1",
              "Mercados proximos, busca e catalogos continuam liberados enquanto a assinatura estiver ativa."
            ) ||
              "Mercados proximos, busca e catalogos continuam liberados enquanto a assinatura estiver ativa."}
          </div>
          <div>
            {t?.(
              "billing.paywall.feature_2",
              "O valor usa a moeda local do usuario com base na regiao configurada no app."
            ) ||
              "O valor usa a moeda local do usuario com base na regiao configurada no app."}
          </div>
        </div>

        {billingOverview.sandbox_mode ? (
          <div
            style={{
              marginTop: 18,
              padding: 14,
              borderRadius: 18,
              background: "#eff6ff",
              border: "1px solid #bfdbfe",
              color: "#1d4ed8",
            }}
          >
            {t?.(
              "billing.paywall.sandbox",
              "Modo sandbox ativo: no desenvolvimento, o botao abaixo ativa a assinatura de teste. Para publicar, conecte Google Play Billing e App Store."
            ) ||
              "Modo sandbox ativo: no desenvolvimento, o botao abaixo ativa a assinatura de teste. Para publicar, conecte Google Play Billing e App Store."}
          </div>
        ) : null}

        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 22 }}>
          <button
            type="button"
            onClick={onActivate}
            disabled={isActivating}
            style={primaryButtonStyle}
          >
            {isActivating
              ? t?.("billing.paywall.activating", "Ativando assinatura...") ||
                "Ativando assinatura..."
              : t?.("billing.paywall.cta", "Continuar com assinatura") ||
                "Continuar com assinatura"}
          </button>
          <button type="button" onClick={onLogout} style={secondaryButtonStyle}>
            {t?.("billing.paywall.logout", "Sair da conta") || "Sair da conta"}
          </button>
          <button type="button" onClick={() => window.location.reload()} style={ghostButtonStyle}>
            {t?.("billing.paywall.refresh", "Atualizar status") || "Atualizar status"}
          </button>
        </div>
      </div>
    </div>
  );
}
